/**
 * Configuration for all monitored services
 */

export interface ServiceConfig {
  name: string
  description: string
  developmentUrl: string
  productionUrl: string
}

export const MONITORED_SERVICES = {
  "agent-gate": {
    name: "Agent Gate API",
    description: "Consolidated backend (auth, billing, MCP, tasks, tester, emails)",
    developmentUrl: "https://dev-api.agent-gate.com",
    productionUrl: "https://api.agent-gate.com",
  },
} as const satisfies Record<string, ServiceConfig>

export type ServiceId = keyof typeof MONITORED_SERVICES

/**
 * Get the appropriate URL for a service based on environment
 */
export function getServiceUrl(serviceId: ServiceId, isProduction = false): string {
  const service = MONITORED_SERVICES[serviceId]
  return isProduction ? service.productionUrl : service.developmentUrl
}

/**
 * Get all service URLs for the current environment
 */
export function getAllServiceUrls(isProduction = false): Record<ServiceId, string> {
  return Object.fromEntries(
    Object.keys(MONITORED_SERVICES).map((key) => [key, getServiceUrl(key as ServiceId, isProduction)]),
  ) as Record<ServiceId, string>
}
